import { CustomPlaybookButtons, CustomPlaybooksList } from '@/modules/rules';

/**
 * My Agents › Support Agent, for a brand with playbooks on (Rules beta): the playbooks that run on every
 * customer message, top to bottom, before Advanced AI answers. "Upset customers go to a person",
 * "Acknowledgements get a quick reply", "Big spenders get a VIP tag" live here. The route's
 * `flag` handle keeps it to brands on the beta.
 */
export default function SupportAgent() {
	return (
		<div className='flex h-full flex-col'>
			<div className='flex h-[60px] shrink-0 items-center justify-between border-b border-gray-300 px-4'>
				<h1 className='text-base font-semibold text-ink'>Support Agent</h1>
				<div className='flex items-center gap-3'>
					<CustomPlaybookButtons place='pre-processing' />
				</div>
			</div>
			<div className='flex-1 overflow-auto'>
				<div className='flex w-[960px] max-w-full flex-col gap-3 px-4 py-4'>
					<p className='text-[12px] leading-4 text-gray-800'>
						Playbooks run on every customer message, top to bottom, before Advanced AI answers. The first one that decides wins; one
						that only acts, like adding a tag, lets the next one run. Check how the customer feels, what they want, their lifetime
						spend or their cart, then reply, tag, assign or hand the ticket to your team.
					</p>
					<CustomPlaybooksList place='pre-processing' />
				</div>
			</div>
		</div>
	);
}
